import gql from 'graphql-tag';

import { getSingleProp, unwrapEdges } from 'src/lib/graphql';
import { executeGqlQuery } from 'src/graphql/client';

const QUERY = gql`
  query HubspotAccounts {
    me {
      id

      hubspotData {
        adAccounts {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const queryHubspotAccounts = () => {
  return executeGqlQuery({
    query: QUERY,
  })
    .then(({ data }) => getSingleProp(data))
    .then((result) => unwrapEdges(result?.hubspotData?.adAccounts?.edges || []));
};
